import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);

  const loadMeta = useCallback(async () => {
    const { data } = await api.get("/settings/bootstrap");
    setMeta(data);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(false);
      return;
    }
    api.get("/auth/me")
      .then(async (r) => {
        await loadMeta();
        setUser(r.data);
      })
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(false);
      });
  }, [loadMeta]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    await loadMeta();
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    setMeta(null);
  };

  const can = (perm) => !!user && user.permissions?.includes(perm);

  return (
    <AuthCtx.Provider value={{ user, meta, login, logout, can, loadMeta }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (user) => (user?.role === "technician" ? "/tecnico" : "/admin");
